import React from 'react';
import Icon from '@components/Icon';
import ConditionalRenderer, { Else, If } from '@components/ConditionalRenderer';
import './style.scss';

const Burger = ({ isNavVisible, onClick }) => (
  <div className={`burger ${isNavVisible && 'active'}`} onClick={onClick}>
    <ConditionalRenderer condition={isNavVisible}>
      <If>
        <Icon type='close' />
      </If>
      <Else>
        <Icon type='burger' />
      </Else>
    </ConditionalRenderer>
  </div>
);

export default Burger;
